import { render, staticRenderFns } from "./FinancesClients.vue?vue&type=template&id=a359df2a&scoped=true&"
import script from "./FinancesClients.vue?vue&type=script&lang=js&"
export * from "./FinancesClients.vue?vue&type=script&lang=js&"
import style0 from "./FinancesClients.vue?vue&type=style&index=0&id=a359df2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359df2a",
  null
  
)

export default component.exports